import React from 'react'
import logger from '../../logger'

interface Props {}

interface State {
  hasError: boolean
  error: Error
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
    }
  }

  static getDerivedStateFromError(err: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: err }
  }

  componentDidCatch(err: Error, errorInfo: any) {
    // You can also log the error to an error reporting service
    logErrorToMyService(err, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <h1>Something went wrong.</h1>
          {process.env.NODE_ENV !== 'production' && (
            <>
              <pre>{JSON.stringify(this.state.error.message)}</pre>
              <pre>
                {this.state.error.stack.split('\n').map(err => (
                  <div key={err}>{err}</div>
                ))}
              </pre>
            </>
          )}
        </>
      )
    }

    return this.props.children
  }
}

function logErrorToMyService(err: Error, errorInfo: any) {
  logger.error('react-client-error', {
    err: err.message,
    errorInfo,
  })
}
